import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[template-modal-content]'
})
export class ContentModalDirective {
    constructor(public tpl: TemplateRef<any>) { }

}
